
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public Seleccionado: number = 0;

        public get Items()
        {

            let ii: { Id?: string, Tipo: 'subtitulo' | 'opcion' | 'titulo'; Icono?: string; Titulo?: string; Accion?: Function; Desactivado?: boolean; }[] = [];

            ii.push( { Tipo: 'titulo', Titulo: 'Nuevo pedido' } );
            ii.push( { Tipo: 'subtitulo', Titulo: 'Seleccione un tipo para continuar' } );

            for ( let item of Pedidos.Tipos.Options )
            {
                ii.push( { Id: item.Id, Tipo: 'opcion', Titulo: item.Descripcion, Accion: () => this.Seleccionar(item) } );
            }

            return ii;

        }

        Seleccionar( item: Pedidos.Tipos )
        {
            this.Controlador.EdicionPedido.Tipo = item;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }
        created()
        {
            this.Controlador.Reiniciar();
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
        }

        onKeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter','Tab', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }

        onKeyUp( e: KeyboardEvent )
        {
            if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'PageUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Items.filter( x => x.Tipo == 'opcion' ).length-1 );
            }
            else if ( e.key == 'Escape' )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado] )
                {
                    this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Accion();
                }
            }
        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items.filter( x => x.Tipo == 'opcion' )[x] )
            {
                this.Seleccionado = x;
                //if ( !this.isVisibleLista( this.Seleccionado ) )
                    this.ScrollToItemLista();
            }
        }

        protected ScrollToItemLista()
        {
            let element = document.getElementById( 'barra-izquierda-lista' );
            let element2 = document.getElementById( 'barra-izquierda-lista-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleLista( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }

        Cerrar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }


    }
